import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC } from 'react';

interface Props extends StyleProps, TestIdProps {
  color?: PrivacyBannerColor;
}

export type PrivacyBannerColor = 'gray' | 'seafoam';

export const PrivacyBanner: FC<Props> = ({ testId, className, style, color = 'gray' }) => {
  return (
    <div
      data-testid={testId}
      className={mc(
        'py-4',
        `flex flex-row justify-center`,
        'text-center',
        color === 'gray' && 'bg-light-gray',
        color === 'seafoam' && 'bg-seafoam',
        className,
      )}
      style={style}
    >
      <p className="text-sm w-8/12 lg:w-full">
        CircleOf takes privacy seriously. Read our{' '}
        <a className="font-bold underline" href="/privacy-policy" target="_blank">
          Privacy Policy
        </a>{' '}
        here.
      </p>
    </div>
  );
};

export default PrivacyBanner;
